import { createSlice } from '@reduxjs/toolkit';

import { loadMilestones, updateMilestone, createMilestone } from './milestones.middleware';
import { logout } from '../../auth/auth-middleware';
import { MilestoneApp } from 'api';

type MilestonesState = {
    list: MilestoneApp[];
    isMilestonesUpdated: boolean;
    newMilestone: {
        entity: MilestoneApp | null;
        error: string | null;
        isLoading: boolean;
    };
    error: string | null;
    isLoading: boolean;
};

const initialState: MilestonesState = {
    list: [],
    isMilestonesUpdated: false,
    newMilestone: {
        entity: null,
        error: null,
        isLoading: false,
    },
    error: null,
    isLoading: false,
};

export const milestonesSlice = createSlice({
    name: 'app/milestones',
    initialState,
    reducers: {
        resetMilestonesUpdated: (state, action) => {
            state.isMilestonesUpdated = action.payload;
        },
        resetMilestones: (state) => {
            state.list = [];
            state.isMilestonesUpdated = false;
            state.error = null;
            state.isLoading = false;
            state.newMilestone = {
                entity: null,
                error: null,
                isLoading: false,
            };
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(loadMilestones.fulfilled, (state, action) => {
                state.list = action.payload.data;
                state.error = null;
                state.isLoading = false;
                state.newMilestone = {
                    entity: null,
                    error: null,
                    isLoading: false,
                };
            })
            .addCase(loadMilestones.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(loadMilestones.rejected, (state, action) => {
                state.error = action.payload as string;
                state.isLoading = false;
            })
            .addCase(updateMilestone.fulfilled, (state, action) => {
                state.isMilestonesUpdated = true;
                state.error = null;
                state.isLoading = false;
            })
            .addCase(updateMilestone.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(updateMilestone.rejected, (state, action) => {
                state.error = action.payload as string;
                state.isLoading = false;
            })
            .addCase(createMilestone.fulfilled, (state, action) => {
                state.newMilestone = {
                    entity: action.payload.data,
                    error: null,
                    isLoading: false,
                };
            })
            .addCase(createMilestone.pending, (state) => {
                state.newMilestone = {
                    entity: null,
                    error: null,
                    isLoading: true,
                };
            })
            .addCase(createMilestone.rejected, (state, action) => {
                state.newMilestone = {
                    entity: null,
                    error: action.error.message as string,
                    isLoading: false,
                };
            })
            .addCase(logout.fulfilled, (state) => {
                state.list = [];
                state.isMilestonesUpdated = false;
                state.error = null;
                state.isLoading = false;
                state.newMilestone = {
                    entity: null,
                    error: null,
                    isLoading: false,
                };
            });
    },
});

export const { resetMilestonesUpdated, resetMilestones } = milestonesSlice.actions;
export default milestonesSlice.reducer;
